// extracted by mini-css-extract-plugin
module.exports = {"ModalBodyContent":"IZ7-0bIj"};